import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from './Button'

export const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation()
  
  const currentLanguage = (i18n.resolvedLanguage ?? i18n.language).split('-')[0] === 'ko' ? 'ko' : 'en'
  
  const toggleLanguage = () => {
    const newLang = currentLanguage === 'en' ? 'ko' : 'en'
    void i18n.changeLanguage(newLang)
  }
  
  const getLanguageLabel = () => {
    return currentLanguage === 'en' ? '🇳🇿 English' : '🇰🇷 한국어'
  }
  
  const getFlag = () => {
    return currentLanguage === 'en' ? '🇳🇿' : '🇰🇷'
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2"
      title={t('languageSwitcher.switchTitle', { language: getLanguageLabel() })}
    >
      <span className="text-lg">{getFlag()}</span>
      <span className="hidden sm:inline">{currentLanguage === 'en' ? 'English' : '한국어'}</span>
      <span className="sm:hidden">{currentLanguage.toUpperCase()}</span>
    </Button>
  )
}

// alternative: dropdown version with flags
export const LanguageSwitcherDropdown: React.FC = () => {
  const { i18n } = useTranslation()
  const currentLanguage = (i18n.resolvedLanguage ?? i18n.language).split('-')[0] === 'ko' ? 'ko' : 'en'
  
  const changeLanguage = (lang: string) => {
    void i18n.changeLanguage(lang)
  }

  return (
    <div className="flex items-center gap-2">
      <select
        value={currentLanguage}
        onChange={(e) => changeLanguage(e.target.value)}
        className="text-sm border border-slate-300 rounded px-3 py-1.5 bg-white text-slate-900 focus:outline-none focus:ring-2 focus:ring-primary"
      >
        <option value="en">🇳🇿 English</option>
        <option value="ko">🇰🇷 한국어</option>
      </select>
    </div>
  )
}

